import { HASH_KEY_TYPE } from '@/enums/map'

interface hashData {
  [key: string]: string
}

const useHash = () => {
  const getHashAll = (): string => {
    return window.location.hash
  }

  const getHashByKey = (key: HASH_KEY_TYPE): string => {
    const hashKeyValuePairs = window.location.hash.replace('#', '').split('&')
    const hashData: hashData = {}
    const hashObject = hashKeyValuePairs.reduce((acc, pair) => {
      const [key, value] = pair.split('=')
      acc[key] = value
      return acc
    }, hashData)
    const value = hashObject[key]
    return value
  }

  const updateHash = (hashInputObject: hashData): string => {
    const hashKeyValuePairs = window.location.hash.replace('#', '').split('&')
    const hashObject: hashData = {}
    if (window.location.hash) {
      hashKeyValuePairs.forEach((pair) => {
        const [key, value] = pair.split('=')
        if (key in hashInputObject) {
          hashObject[key] = hashInputObject[key]
        } else {
          hashObject[key] = value
        }
      })
    }
    Object.entries(hashInputObject).map(([key, value]) => {
      hashObject[key] = value
    })

    const newHash = Object.entries(hashObject)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')

    return `#${newHash}`
  }

  return { getHashByKey, updateHash, getHashAll }
}

export default useHash
